<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">CLASIFICAR PALLETS</h1>
      <b-row>
        <b-col sm="12" md="12" lg="8">
          <b-card no-body>
            <b-row>
              <b-col>
                <h2 class="mt-2 ml-2">Tabla de pallets</h2>
                <p class="ml-2">Pinche los pallets para seleccionar</p>
              </b-col>
              <b-col>
                <b-spinner v-if="loading" small class="m-2 float-right"></b-spinner>
              </b-col>
            </b-row>

            <v-server-table
              :url="url"
              :columns="columns"
              :options="options"
              @row-click="selectRow"
              theme="bootstrap4"
              template="default"
              ref="table"
              id="dataTable"
            ></v-server-table>
          </b-card>
        </b-col>
        <b-col sm="12" md="12" lg="4">
          <b-card no-body>
            <b-row>
              <b-col>
                <h2 class="m-2">Pallets seleccionados</h2>
              </b-col>
              <b-col class="m-2">
                <v-select
                  :options="classification_options"
                  label="name"
                  :reduce="(e) => e.id"
                  v-model="form.classification"
                >
                  <template v-slot:option="option">
                    <span :class="'text-' + option.color"></span>
                    <i :class="'fa fa-circle text-' + option.color"></i> {{ option.name }}
                  </template>
                </v-select>
              </b-col>
            </b-row>
            <b-table :items="form.selected_pallets" :fields="columns_selected_pallets">
              <template v-slot:cell(acciones)="row">
                <a href="#" @click.prevent="removeRow(row.item)"><i class="fa fa-close text-danger"></i></a>
              </template>
            </b-table>
          </b-card>
          <b-button @click.prevent="onSubmit" class="float-right px-5" variant="primary"><b>Guardar</b></b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import { required } from "vuelidate/lib/validators";
Vue.use(ServerTable);
window.axios = require("axios");
export default {
  name: "ChangePalletStatus",
  components: {
    ServerTable
  },
  validations: {
    form: {
      classification: { required },
      selected_pallets: { required }
    }
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    this.getClassifications();
  },
  computed: {
    url() {
      return "/api/qc/classification/pallets/";
    },
    mapPalletsIds() {
      return this.form.selected_pallets.map((item) => item.id);
    }
  },
  methods: {
    resetForm() {
      this.form.selected_pallets = [];
      this.form.classification = null;
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError || this.form.selected_pallets.length == 0) {
        this.$swal.fire("Atención", "Debe seleccionar almenos 1 pallet y seleccionar una clasificación", "warning");
        return;
      }
      this.onSubmitSuccess();
    },
    async onSubmitSuccess() {
      const self = this;
      self.loading = true;
      const payload = {
        pallet_list: self.mapPalletsIds
      };
      try {
        const res = await self.$axios.put(
          `/api/qc/classification/${self.form.classification}/bulk_update_pallets/`,
          payload
        );
        if (res.status == 200) {
          self.$swal.fire("Operación realizada con éxito", "", "success");
          self.resetForm();
        }
        self.loading = false;
      } catch (e) {
        self.loading = false;
        console.log(e);
      }
    },
    async getClassifications() {
      const self = this;
      self.loading = true;
      try {
        const res = await self.$axios.get("/api/qc/classification/?no_page=true");
        res.data.forEach((item) => {
          self.classification_options.push(item);
        });
      } catch (e) {
        console.log(e);
      }
    },
    removeRow(e) {
      const item = {
        id: e.id,
        number: e.number
      };
      this.form.selected_pallets = this.form.selected_pallets.filter((x) => x.id !== item.id);
    },
    selectRow(e) {
      const item = {
        id: e.row.id,
        number: e.row.number
      };
      const repeated = this.form.selected_pallets.find((x) => x.id === item.id);
      if (!repeated) {
        this.form.selected_pallets.push(item);
      } else {
        this.$toast.error("Este pallet ya fue seleccionado", "");
      }
    }
  },
  data() {
    return {
      loading: true,
      form: {
        selected_pallets: [],
        classification: null
      },
      classification_options: [{ id: null, name: "Seleccione nueva clasificación" }],
      columns: ["number", "companies", "lots", "container"],
      columns_selected_pallets: [
        { key: "number", label: "Numero" },
        { key: "acciones", label: "" }
      ],
      options: {
        debounce: 800,
        skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:",
          loading: "Cargando...",
          defaultOption: "Selecione {column}"
        },
        perPage: 15,
        perPageValues: [15, 25, 50],
        filterByColumn: true,
        filterable: ["number", "lots", "companies", "container"],
        listColumns: {},
        headings: {
          number: "Número",
          lots: "Lote",
          companies: "Productor",
          container: "Formato/Recipiente"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
